<script lang="ts" setup>
import { Slot } from 'reka-ui'

defineOptions({
  inheritAttrs: false
})
</script>

<template>
  <Suspense>
    <Slot v-bind="$attrs">
      <slot />
    </Slot>

    <template #fallback>
      <div class="flex-center" v-bind="$attrs">
        <Spinner class="$text-[$color-neutral,@theme-colors-primary-500] text-$text" />
      </div>
    </template>
  </Suspense>
</template>
